import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ENV_CONFIG } from '@ps/core-config';
import { FeasibilityResult } from '@ps/survey-utils';
import { map, Observable } from 'rxjs';
import {
  FeasibilityRequestDto,
  FeasibilityResponseDto,
  FeasibilityUnusedQualificationNoticeDto,
} from './dtos/feasibility.dto';
import { FeasibilityMapper } from './mappers/feasibility.mapper';

@Injectable({ providedIn: 'root' })
export class FeasibilityApi {
  private readonly _env = inject(ENV_CONFIG);
  private readonly _http = inject(HttpClient);

  private readonly _baseUrl = this._env.pureSpectrum.feasibilityUrl;
  private readonly _mainUrl = this._env.pureSpectrum.url;

  private readonly _mapper = new FeasibilityMapper();

  public getFeasibility(
    request: FeasibilityRequestDto,
  ): Observable<FeasibilityResult> {
    return this._http
      .post<FeasibilityResponseDto>(
        `${this._baseUrl}/feasibility/v3?summary=2&UI=1`,
        request,
      )
      .pipe(map((dto) => this._mapper.fromDto(dto)));
  }

  public notifyUnusedQualification(
    notice: FeasibilityUnusedQualificationNoticeDto,
  ): Observable<unknown> {
    return this._http.post(
      `${this._mainUrl}/support/notify/feasibility`,
      notice,
    );
  }
}
